export function clamp(min, max, val) {
    return Math.min(max, Math.max(min, val));
}
export const swipe = (node, param = { threshold: 20 }) => {
    let start = 0;
    let end = 0;
    let swiping = false;
    function handleGesture() {
        if (end < start && start - end > param.threshold) {
            node.dispatchEvent(new CustomEvent("leftswipe"));
        }
        if (end > start && end - start > param.threshold) {
            node.dispatchEvent(new CustomEvent("rightswipe"));
        }
    }
    function touchMove(e) {
        if (!swiping)
            return;
        const diffx = start - e.changedTouches[0].screenX;
        node.dispatchEvent(new CustomEvent("swiping", {
            bubbles: true,
            cancelable: true,
            detail: { diffx },
        }));
    }
    function touchStart(e) {
        start = e.changedTouches[0].screenX;
        swiping = true;
    }
    function touchEnd(e) {
        end = e.changedTouches[0].screenX;
        swiping = false;
        handleGesture();
    }
    const options = {
        capture: true,
        passive: true,
    };
    node.addEventListener("touchstart", touchStart, options);
    node.addEventListener("touchend", touchEnd, options);
    node.addEventListener("touchmove", touchMove, options);
    return {
        destroy() {
            node.removeEventListener("touchstart", touchStart, true);
            node.removeEventListener("touchend", touchEnd, true);
            node.removeEventListener("touchmove", touchMove, true);
        },
    };
};
